import classNames from "classnames";
import React from "react";

export default function ({ className }) {
  return (
    <picture
      className={classNames("rounds-background-image", {
        [className]: !!className,
      })}
    >
      <source srcSet="/assets/images/rounds.webp" type="image/webp" />
      <img
        src="/assets/images/rounds.png"
        alt="img"
        className="rounds-background-wrapper__round"
      />
    </picture>
  );
}
